import React, { useEffect, useRef } from "react";
import StatsSection from "./StatsSection";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// const DonutChart = () => {
//   const chartRef = useRef(null);
//   const segmentsRef = useRef([]);
//   const textRef = useRef([]);

//   const colors = [
//     "#F7FCF5",
//     "#E2F3D9",
//     "#C1E5B4",
//     "#8DCE85",
//     "#59B567",
//     "#05712F",
//   ];

//   const data = [17, 17, 17, 17, 17, 17];
//   const total = data.reduce((a, b) => a + b, 0);
//   const radius = 35;
//   const strokeWidth = 18;
//   const center = 50;
//   const circumference = 2 * Math.PI * radius;

//   useEffect(() => {
//     // Chart segments ka drawing animation
//     gsap.fromTo(
//       segmentsRef.current,
//       { strokeDashoffset: circumference },
//       {
//         strokeDashoffset: (i) => {
//           const percent = data[i] / total;
//           return -(i * percent * circumference); // Yeh calculation offset ko maintain karti hai
//         },
//         duration: 1.5,
//         ease: "power2.out",
//         stagger: 0.1,
//         scrollTrigger: {
//           trigger: chartRef.current,
//           start: "top 80%",
//         },
//       },
//     );

//     // Text labels ka fade-in
//     gsap.fromTo(
//       textRef.current,
//       { opacity: 0, scale: 0 },
//       {
//         opacity: 1,
//         scale: 1,
//         duration: 0.5,
//         stagger: 0.1,
//         delay: 1,
//         scrollTrigger: {
//           trigger: chartRef.current,
//           start: "top 80%",
//         },
//       },
//     );
//   }, [circumference, data, total]);

//   let cumulativePercent = 0;

//   return (
//     <div
//       ref={chartRef}
//       className="relative w-full max-w-[80%] aspect-square flex items-center justify-center"
//     >
//       <svg
//         viewBox="0 0 100 100"
//         className="w-full h-full transform -rotate-90 drop-shadow-xl"
//       >
//         {data.map((value, index) => {
//           const percent = value / total;
//           const strokeDasharray = `${percent * circumference} ${circumference}`;
//           const strokeDashoffset = -(cumulativePercent * circumference);

//           const angle = (cumulativePercent + percent / 2) * 360;
//           const radians = (angle * Math.PI) / 180;
//           const labelX = center + radius * Math.cos(radians);
//           const labelY = center + radius * Math.sin(radians);

//           cumulativePercent += percent;

//           return (
//             <g key={index}>
//               <circle
//                 ref={(el) => (segmentsRef.current[index] = el)}
//                 cx={center}
//                 cy={center}
//                 r={radius}
//                 fill="transparent"
//                 stroke={colors[index]}
//                 strokeWidth={strokeWidth}
//                 strokeDasharray={strokeDasharray}
//                 strokeDashoffset={strokeDashoffset}
//                 className="transition-all duration-700 ease-out"
//               />
//               <text
//                 ref={(el) => (textRef.current[index] = el)}
//                 x={labelX}
//                 y={labelY}
//                 fill={index === 5 ? "#ffffff" : "#1b0e02"}
//                 fontSize="4"
//                 fontWeight="bold"
//                 textAnchor="middle"
//                 alignmentBaseline="middle"
//                 transform={`rotate(90 ${labelX} ${labelY})`}
//                 className="font-[parkinsans]"
//               >
//                 17%
//               </text>
//             </g>
//           );
//         })}
//       </svg>
//     </div>
//   );
// };

const BiomassSection = () => {
  const containerRef = useRef(null);
  const leftContentRef = useRef(null);
  const statsListRef = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Title and Description animation
      gsap.from(".animate-text", {
        y: 50,
        opacity: 0,
        duration: 1,
        stagger: 0.2,
        scrollTrigger: {
          trigger: ".animate-text",
          start: "top 85%",
        },
      });

      // Left side content slide-in
      gsap.from(leftContentRef.current, {
        x: -100,
        opacity: 0,
        duration: 1,
        scrollTrigger: {
          trigger: leftContentRef.current,
          start: "top 80%",
        },
      });

      // Icon list items animation
      gsap.from(statsListRef.current, {
        x: -50,
        opacity: 0,
        duration: 0.8,
        stagger: 0.2,
        scrollTrigger: {
          trigger: leftContentRef.current,
          start: "top 70%",
        },
      });
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={containerRef} className="w-full">
      <div className="w-full">
        <div className="flex flex-col items-center gap-[24px] md:gap-[36px] lg:gap-[48px] px-4 md:px-[28px] lg:px-[56px] pt-[50px] md:pt-[75px] lg:pt-[100px]">
          <div className="flex flex-col items-center gap-[10px] md:gap-[15px] lg:gap-[20px] w-full max-w-[1496px]">
            <h2 className="animate-text text-[30px] md:text-[60px] lg:text-[100px] font-[parkinsans] font-bold leading-[42px] md:leading-[84px] lg:leading-[140px] text-center text-[#343163]">
              Our Network Capacity
            </h2>
            <p className="animate-text text-[14px] md:text-[18px] lg:text-[24px] font-poppins font-light leading-[22px] md:leading-[28px] lg:leading-[38px] text-center text-[#1b0e02] w-full">
              UTPANN operates a strong and expanding distribution network with
              250+ authorized distributors, serving over 91,000 MT of organic
              fertilizer annually across Gujarat. With a proven logistics and
              supply system in place, UTPANN is now expanding its reach to
              Maharashtra and Rajasthan, ensuring wider access to quality
              organic fertilizers for sustainable agriculture.
            </p>
          </div>
          <StatsSection />
        </div>

        {/* <div className="flex flex-col lg:flex-row w-full overflow-hidden">
    
          <div
            ref={leftContentRef}
            className="w-full lg:w-1/2 bg-[#dcfbaf] flex flex-col gap-[19px] md:gap-[28px] lg:gap-[38px] justify-center items-center px-[23px] md:px-[34px] lg:px-[46px] py-[63px] md:py-[94px]"
          >
            <div className="flex flex-col items-start w-[88%]">
              <h3 className="text-[30px] md:text-[45px] lg:text-[60px] font-[parkinsans] font-bold leading-[42px] md:leading-[63px] lg:leading-[84px] text-left text-[#343163] w-full">
                Sustainable Biomass Selection
              </h3>
              <p className="text-[12px] md:text-[16px] lg:text-[20px] font-poppins font-light leading-[18px] md:leading-[24px] lg:leading-[30px] text-justify text-[#1c233a] w-[94%] mt-4">
                The quality and characteristics of biochar are significantly
                influenced by the type of biomass used in production. We select
                manufacturing partners who carefully choose sustainable biomass
                sources that would otherwise contribute to waste or pollution
                problems.
              </p>
            </div>

            <div className="flex flex-col gap-[12px] md:gap-[18px] lg:gap-[24px] w-full md:px-[52px]">
              {["Waste Reduction", "Fair Sourcing", "Quality Control"].map(
                (title, i) => (
                  <div
                    key={title}
                    ref={(el) => (statsListRef.current[i] = el)}
                    className="flex gap-[5px] md:gap-[7px] lg:gap-[10px] items-center w-full"
                  >
                    <img
                      src="/assets/utpannProduction/selectionIcon.png"
                      alt="icon"
                      className="w-[20px] md:w-[30px] lg:w-[40px] h-[20px] md:h-[30px] lg:h-[40px]"
                    />
                    <div className="flex flex-col items-start w-full">
                      <h4 className="text-[14px] md:text-[18px] lg:text-[24px] font-[parkinsans] font-bold leading-[20px] md:leading-[25px] lg:leading-[34px] text-left text-[#1b0e02]">
                        {title}
                      </h4>
                      <p className="text-[12px] md:text-[16px] lg:text-[20px] font-poppins font-light leading-[18px] md:leading-[24px] lg:leading-[30px] text-left text-[#1c233a]">
                        {i === 0 &&
                          "Converting agricultural waste into valuable resources"}
                        {i === 1 &&
                          "Supporting local farmers through biomass purchase programs"}
                        {i === 2 &&
                          "Ensuring rigorous testing of all incoming biomass materials"}
                      </p>
                    </div>
                  </div>
                ),
              )}
            </div>
          </div>

          <div className="w-full lg:w-1/2 bg-[linear-gradient(153deg,#195939_0%,#031312_100%)] flex flex-col gap-[20px] md:gap-[30px] lg:gap-[40px] justify-start items-center px-[28px] md:px-[42px] lg:px-[56px] py-[60px]">
            <h3 className="animate-text text-[24px] md:text-[36px] lg:text-[45px] font-[parkinsans] font-bold text-center text-white">
              Biomass Sourcing Statistics
            </h3>
            <DonutChart />
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default BiomassSection;
